import { render, staticRenderFns } from "./digitalocean.vue?vue&type=template&id=5e6dabd1&"
import script from "./digitalocean.vue?vue&type=script&lang=js&"
export * from "./digitalocean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports